
import Account from '../models/Account';
import request from '../shared/http';

const cache = {};

class MyAccountService {
  getURL() {
    return '/accounts/@me';
  }

  async fetch() {
    if (!cache.account) {
      const response = await request.get(this.getURL());
      const { data } = response;
      cache.account = new Account({
        id: data.id,
        firstName: data.first_name,
        lastName: data.last_name,
        organizationId: data.organization_id,
        timeZone: data.timezone,
        email: data.email,
        mobile: data.mobile,
        imageUpdatedAt: data.image_updated_at,
      });
    }
    return cache.account;
  }

  get() {
    return cache.account;
  }

  async updateAccount({
    firstName,
    lastName,
    timeZone,
    imageUpdatedAt,
  }) {
    const response = await request.put(this.getURL(), {
      first_name: firstName,
      last_name: lastName,
      locale: 'En',
      timezone: timeZone,
    });
    cache.account.setFirstName(firstName);
    cache.account.setLastName(lastName);
    cache.account.setTimeZone(timeZone);
    cache.account.setImageUpdatedAt(imageUpdatedAt);
    return response;
  }

  async updateMedia({ accountId, file }) {
    const formData = new FormData();
    formData.append('file', file);
    const url = `/accounts/${accountId}/image`;
    return request.put(
      url,
      formData,
      {
        headers: {
          'content-type': 'multipart/form-data',
        },
      },
    );
  }

  async deleteMedia(accountId) {
    const url = `/accounts/${accountId}/image`;
    return request.delete(url);
  }

  async updateAccountPassword({ currentPassword, newPassword }) {
    return request.put(`${this.getURL()}/password`, {
      current_password: currentPassword,
      next_password: newPassword,
    });
  }

  updateAccountEmail(email) {
    return request.put(`${this.getURL()}/email`, { email });
  }

  updateAccountMobile(mobile) {
    return request.put(`${this.getURL()}/mobile`, { mobile });
  }
}

export default new MyAccountService();
